export const API_BASE_URL = 
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_BASE_URL
    : 'http://localhost:8888/api/';

export const BASE_URL =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_BASE_URL
    : 'http://localhost:8888/';

export const DOWNLOAD_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_DOWNLOAD_BASE_URL
    : 'http://localhost:8888/';

export const ACCESS_TOKEN_NAME = 'x-auth-token';

